(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vbb-main-footer"]) return;
  try {
    
window.addEventListener('DOMContentLoaded', () => {
  const toggleButtons = document.querySelectorAll('.vbb-main-footer__core__link-lists button');

  const shopifyFormStyleId = 'vbb-shopify-form-green-style';
  const shopifyFormStyles = `
    :host {
      font-family: var(--font-jha-times-now) !important;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    span,
    a,
    legend,
    button,
    input,
    textarea,
    select {
      font-family: var(--font-jha-times-now) !important;
      color: black !important;
    }

    label {
      font-family: var(--font-gotham) !important;
      // text-transform: uppercase !important;
      font-weight: 300 !important;
      color: black !important;
    }

    h2 {
      font-weight: 400 !important;
    }

    input,
    textarea,
    select,
    button {
      font-family: var(--font-gotham) !important;
      border-radius: 0 !important;

    }

    button,
    input[type='submit'] {
      font-family: var(--font-gotham) !important;
    }
    form {
      margin-top: -1rem !important;
      padding-right: 4px !important;
    }
    form button {
      font-family: var(--font-untitled-sans) !important;
      cursor: pointer !important;
      text-transform: uppercase !important;
      transition: all .3s !important;
      font-size: 1.2rem !important;
      font-weight: 400 !important;
      text-align: center !important;
      user-select: none !important;
      color: var(--color-bg) !important;
      border: 0 !important;
      border-radius: 0 !important;
      text-decoration: none !important;
    }
    div:has(fieldset) {
      padding-bottom: 0 !important;
    }
    section:has(p) {
      margin-bottom: 15px !important;
    }
  `;

  const applyShopifyFormStyles = shopifyForm => {
    if (!shopifyForm) return false;

    const shadowRoot = shopifyForm.shadowRoot;
    if (!shadowRoot) return false;

    if (shadowRoot.getElementById(shopifyFormStyleId)) return true;

    const style = document.createElement('style');
    style.id = shopifyFormStyleId;
    style.textContent = shopifyFormStyles;

    shadowRoot.appendChild(style);
    return true;
  };

  const watchShopifyForms = () => {
    const shopifyForms = document.querySelectorAll('shopify-forms-embed');
    let hasStyledForm = false;

    shopifyForms.forEach(shopifyForm => {
      if (applyShopifyFormStyles(shopifyForm)) {
        hasStyledForm = true;
      }
    });

    return hasStyledForm;
  };

  const styleShopifyFormsWhenReady = () => {
    if (watchShopifyForms()) return;

    const observer = new MutationObserver(() => {
      if (watchShopifyForms()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(() => observer.disconnect(), 10000);
  };

  toggleButtons.forEach(toggleButton => toggleButton.addEventListener('click', e => {
    e.target.closest('nav').classList.toggle('active');
  }));

  styleShopifyFormsWhenReady();
});

  } catch(e) { console.error(e); }
})();
})();
